export class Assets {
    static APPLE_ICON = "/img/apple-icon.png"
    static DOWNLOAD_ON_APP_STORE = "/img/download_on_app_store.svg"
    static IOS_APP_SCREENSHOT = "/img/ios-app-screenshot.png"
}